export const getAllChannels = () => {
  return `
      SELECT 
        Canal_de_Atendimento__c
      FROM 
        Membros__c
      WHERE
      Canal_de_Atendimento__c != null
      ORDER BY
        Canal_de_Atendimento__c
        `;
};
